import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from '../../../services/login.service';

declare let $: any;

@Component({
  selector: 'app-sessionexpired',
  templateUrl: './sessionexpired.component.html',
  styleUrls: ['./sessionexpired.component.css']
})
export class SessionexpiredComponent implements OnInit {

    constructor(private router: Router, private route: ActivatedRoute, private LService: LoginService, private fb: FormBuilder) { }

    LoginForm: FormGroup;
    windowHeight: number;
    TokenID: string;

    ngOnInit(): void {
        this.windowHeight = window.innerHeight;

        this.createForm();

        var qrStr = window.location.search;
        var spQrStr = qrStr.substring(1);
        var arrQrStr = new Array();
        var arr = spQrStr.split('=');

        for (var i = 0; i < arr.length; i++) {

            var tokenid = arr[1];
            this.TokenID = tokenid;
        }
        if (this.TokenID != null || this.TokenID != undefined) {
            this.deleteToken(); 
        }
        localStorage.removeItem('TokenID');
        
    }

    createForm() {
        this.LoginForm = this.fb.group({
            ID: 0,
        });
    }

    deleteToken() {
        this.LoginForm.value.ID = this.TokenID;
        this.LService.getDeleteToken(this.LoginForm.value).subscribe(() => {
            //this.allItems = data;
        });
    }


    OnBackLogin() {

        this.router.navigateByUrl("/login", {
            replaceUrl: true
        });
    }

}
